import { render, staticRenderFns } from "./ExportEvents.vue?vue&type=template&id=56e8cd93"
import script from "./ExportEvents.vue?vue&type=script&lang=ts"
export * from "./ExportEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports